import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import Header from '../../../Header';
import { PrimaryCTA } from '../../../Buttons';
import { t } from '../../../../helpers/t';
import get from 'lodash/get';

export default function ListingDraftReviewalHeader() {
  const { __CLIENT_HYDRATED__ } = useSelector((state) => state.layout);
  const { open_drafts } = useSelector((state) => state.listing, shallowEqual);
  const draft = get(open_drafts, '[0]');

  useEffect(() => {
    if (__CLIENT_HYDRATED__) {
      window.pendingDraft = {
        id: draft.id,
        title: !!draft.title,
        description: !!draft.description,
        photos: !!draft.photos,
        virtual_tour_url: !!draft.virtual_tour_url,
      };
    }
  }, [__CLIENT_HYDRATED__]);

  return (
    <Header colorScheme="warning">
      <div className="flex flex-col items-center justify-center" data-ng-cloak>
        <div className="font-light text-orange-800 text-center">
          {t('listings.show.statuses.pendingDraft')}
        </div>
        <div>
          <PrimaryCTA type="warning" data-ng-show="!viewingDraft" data-ng-click="viewDraft()">
            {t('listings.show.statuses.draft.viewChanges')}
          </PrimaryCTA>

          <PrimaryCTA type="warning" data-ng-show="viewingDraft" data-ng-click="hideDraft()">
            {t('listings.show.statuses.draft.hideChanges')}
          </PrimaryCTA>
        </div>
        <div className="grid grid-cols-2 gap-x-2">
          <PrimaryCTA type="success" data-ng-show="viewingDraft" data-ng-click="approveDraft()">
            {t('listings.show.statuses.draft.approve')}
          </PrimaryCTA>

          <PrimaryCTA type="error" data-ng-show="viewingDraft" data-ng-click="rejectDraft()">
            {t('listings.show.statuses.draft.reject')}
          </PrimaryCTA>
        </div>
      </div>
    </Header>
  );
}
